import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import moment, { Moment } from "moment";

@Injectable({
  providedIn: "root",
})
export class UtilService {
  paramsToQueryString(params: any, isFormData: boolean = false): string {
    let result = isFormData ? "" : "?";

    for (let propertyName in params) {
      if (
        params?.[propertyName] !== undefined &&
        params?.[propertyName] !== null &&
        params?.[propertyName] !== ""
      ) {
        if (Array.isArray(params[propertyName])) {
          for (const item of params[propertyName]) {
            result += propertyName + "=" + item + "&";
          }
        } else {
          result += propertyName + "=" + params[propertyName] + "&";
        }
      }
    }
    return result.substring(0, result.length - 1);
  }

  nameUpperFirstLetter(str: string): string {
    if (str == null) return "";

    let strArr = str.split(" ");

    for (let i = 0; i < strArr.length; i++) {
      strArr[i] =
        strArr[i].length > 2
          ? strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1).toLowerCase()
          : strArr[i].toLowerCase();
    }

    return strArr.join(" ");
  }

  isValidDateForm(formControlName: AbstractControl) {
    if (formControlName.value) {
      const dateString: Date = formControlName.value.toDate();
      const day = dateString.getDate();
      const month = dateString.getMonth() + 1;
      const year = dateString.getFullYear();
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      const currentDay = new Date().getDate();

      if (
        year < currentYear ||
        month <= 0 ||
        (month < currentMonth && year == currentYear) ||
        month > 12
      )
        return { invalidDate: true };

      if (year == currentYear && month == currentMonth + 1 && day < currentDay)
        return { dateLessThanCurrent: true };

      return null;
    }

    return { invalidDate: true };
  }

  isValidHourForm(formControlName: AbstractControl) {
    if (formControlName.value) {
      const hourString = formControlName.value;

      if (hourString.length != 4) return { invalidHour: true };

      const hour = parseInt(hourString[0] + hourString[1]);
      const minutes = parseInt(hourString[2] + hourString[3]);

      if (hour < 0 || hour > 24) return { invalidHour: true };

      if (minutes < 0 || minutes > 59) return { invalidHour: true };

      return null;
    }

    return { invalidHour: true };
  }

  isMoreThanCurrentHour(formControlName: AbstractControl) {
    if (formControlName.value) {
      const hourString = formControlName.value;
      const hour = parseInt(hourString[0] + hourString[1]);
      const minutes = parseInt(hourString[2] + hourString[3]);
      const currentHour = new Date().getHours();
      const currentMinutes = new Date().getMinutes();

      if (
        hour < currentHour ||
        (hour == currentHour && minutes < currentMinutes)
      )
        return { invalidCurrentHour: true };

      return null;
    }

    return { invalidCurrentHour: true };
  }

  isLessThanCurrentHour(formControlName: AbstractControl) {
    if (formControlName.value) {
      const hourString = formControlName.value;
      const hour = parseInt(hourString[0] + hourString[1]);
      const minutes = parseInt(hourString[2] + hourString[3]);
      const currentHour = new Date().getHours();
      const currentMinutes = new Date().getMinutes();

      if (
        hour > currentHour ||
        (hour == currentHour && minutes > currentMinutes)
      )
        return { invalidRidCurrentHour: true };

      return null;
    }

    return { invalidRidCurrentHour: true };
  }

  isValidDates(formControlName: AbstractControl) {
    const startDate = formControlName.get("dataInicio").value;
    const endDate = formControlName.get("dataFim").value;

    if (startDate && endDate) {
      if (endDate < startDate) return { startDateMoreThanEnd: true };

      return null;
    }

    return { invalidDate: true };
  }

  verifyIsCurrentDate(dateString) {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();
    let day;
    let month;
    let year;

    if (!dateString) return false;

    if (typeof dateString == "string") {
      if (dateString.length != 8) return false;

      day = parseInt(dateString[0] + dateString[1]);
      month = parseInt(dateString[2] + dateString[3]);
      year = parseInt(
        dateString[4] + dateString[5] + dateString[6] + dateString[7]
      );
    } else {
      const convertedDate = (dateString as Moment).toDate();

      day = convertedDate.getDate();
      month = convertedDate.getMonth() + 1;
      year = convertedDate.getFullYear();
    }

    return (
      day == currentDay && month == currentMonth + 1 && year == currentYear
    );
  }

  getEnumKey(valueEnum, Enum) {
    for (const [key, value] of Object.entries(Enum))
      if (value == valueEnum) return key;
  }

  getEnumKeyValue(Enum): { key: string; value: string }[] {
    const arr = [];

    for (const [key, value] of Object.entries(Enum)) arr.push({ key, value });

    return arr;
  }

  getBlobFileName(response: HttpResponse<Blob>) {
    let filename: string;

    try {
      const contentDisposition: string = response.headers.get(
        "Content-Disposition"
      );

      filename = contentDisposition
        .split(";")[1]
        .trim()
        .split("=")[1]
        .replace(/"/g, "");
    } catch (e) {
      filename = "arquivo";
    }

    return filename;
  }

  convertDateAndHourToString(date: Moment | string, hour: string) {
    if (date == null || hour == null) return null;

    if (hour.length == 4) {
      if (typeof date == "object")
        return `${date.date().toString().padStart(2, "0")}/${(date.month() + 1)
          .toString()
          .padStart(2, "0")}/${date.year()} ${hour[0]}${hour[1]}:${hour[2]}${
          hour[3]
        }`;
      else
        return `${date[0]}${date[1]}/${date[2]}${date[3]}/${date[4]}${date[5]}${date[6]}${date[7]} ${hour[0]}${hour[1]}:${hour[2]}${hour[3]}`;
    } else return "";
  }

  convertDate(date) {
    if (typeof date === "undefined" || date === null) {
      return null;
    }
    return moment(date).format("DD/MM/YYYY");
  }

  isValidDateFormParameterization(formControlName: AbstractControl) {
    if (formControlName.value) {
      const dateString = convertDate(formControlName.value);
      const dateSplit = dateString.split("/");
      const day = Number(dateSplit[0]);
      const month = Number(dateSplit[1]);
      const year = Number(dateSplit[2]);
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      const currentDay = new Date().getDate();

      if (
        year < currentYear ||
        month <= 0 ||
        (month < currentMonth + 1 && year == currentYear) ||
        month > 12
      )
        return { dateLessThanCurrent: true };

      if (year == currentYear && month == currentMonth + 1 && day < currentDay)
        return { dateLessThanCurrent: true };

      return null;
    }

    function convertDate(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }

  public findInvalidControls(form: FormGroup) {
    const invalidControls = [];

    function checkValue(value) {
      return (
        value != null &&
        (!value.length || value.length > 0) &&
        typeof value == "object"
      );
    }

    function pushInvalidControls(name, controls) {
      if (!controls[name] || controls[name].valid || controls[name].disabled)
        return;

      if (checkValue(controls[name].value)) {
        for (const subName in controls[name].controls) {
          const subControl = controls[name].controls;

          pushInvalidControls(subName, subControl);
        }
      } else invalidControls.push(name);
    }

    for (const name in form.controls) {
      pushInvalidControls(name, form.controls);
    }

    return invalidControls;
  }

  public numberWithCommas(value: number) {
    if (!value) return "00,00";

    const formato = { minimumFractionDigits: 2 };

    return value.toLocaleString("pt-BR", formato);
  }

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });

    return blob;
  }

  convertDateStringToMoment(date: string) {
    return moment()
      .date(Number(date.slice(0, 2)))
      .month(Number(date.slice(2, 4)) - 1)
      .year(Number(date.slice(4, 8)));
  }

  replaceValueToNumber(value: any): number {
    if (value != null) {
      const stringValue = value.toString().replace(/[^\d,.-]/g, '');
      if (stringValue.includes(',')) {
        return Number(stringValue.replace(',', '.'));
      } else {
        return Number(stringValue);
      }
    } else {
      return NaN; 
    }
  }

  public formatCurrency(isDollarPrefix: boolean, value: number) {
    let formato;

    if (isDollarPrefix) {
      formato = { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2, currencyDisplay: 'narrowSymbol'};
    } else {
      formato = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2};
    }

    return  Intl.NumberFormat('pt-BR', formato).format(value);
  }

}
